import { render, staticRenderFns } from "./wtMakeCopy.component.vue?vue&type=template&id=76f73203&scoped=true&"
import script from "./wtMakeCopy.component.vue?vue&type=script&lang=js&"
export * from "./wtMakeCopy.component.vue?vue&type=script&lang=js&"
import style0 from "./wtMakeCopy.component.vue?vue&type=style&index=0&id=76f73203&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76f73203",
  null
  
)

export default component.exports